import React from 'react'
import ProgressBar from 'sprockets_react/job_wizards/components/ProgressBar'
import { EventEmitter } from 'events'
import { Job, JobWizard, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.MessageChannel = { 
  hasMobileChannel: function () {
    if (typeof(JobWizardChannel) == "undefined") {
      return false;
    }
    
    return true;
  },

  sendMessage: function (message) {
    if (this.hasMobileChannel()) {
      JobWizardChannel.postMessage(message)
      return true;
    }

    return false;
  }
}

JobWizardMobile.StepSequence.init()

JobWizardMobile.Emitter = JobWizardMobile.Emitter || new EventEmitter()

JobWizardMobile.Modal = React.createClass({

  getInitialState: function() {
    return {
      job: Job.Data,
      currentStep: this.wizard.Steps[0],
      loading: false
    }

  },

  componentDidMount: function () {
    let $jobModal = $('#job-modal')

    if (this.props.id) {
      JobWizard.Utils.initJob(this.props)
    }

    this.setExclusiveBusinessId()

    let browserCloseListener = () => {
      window.addEventListener('beforeunload', this.handleBrowserClose)
    }

    function handleModalExit() {
      if(Job.Data.lastSlide) {
        redirectPage()
        return;
      }

      if (Job.Data.id !== null) {
        $jobModal.find('.close-modal-warning').velocity('slideUp').end()
                 .find('.close').rmHidden()

        if (Job.Data.additionalQuestion) {
          setTimeout(() => {
            redirectPage()
          }, 500)
        }
        return;
      }

      Job.PostingProgressActions.updateTracking({ exitType: 'modal_exit' })
      Job.PostingProgressActions.createPostingProgress()
      Job.Actions.resetData()
      this.setState({currentStep: this.wizard.Steps[0]})
      $jobModal.modal('hide')
      $jobModal.find('.modal-stay').trigger('click') // hide this warning
      window.removeEventListener('beforeunload', this.handleBrowserClose)
      return false;
    }

    function redirectPage() {
      let jobID = Job.Data.id
      let url = ''
      var message = JSON.stringify({message_type: 'jobs_wizard', message: 'JOB_POSTING_COMPLETED', payload: jobID})

      if (JobWizardMobile.MessageChannel.sendMessage(message) == true) {
        return;
      }

      switch (Job.Data.referrer.cta) {
        case 'profile': {
          url = `/jobs/${jobID}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          url = `/jobs/${jobID}/bcardjob?successful_job=true`
        }
        default: {
          url = `/jobs/${jobID}/posted?successful_job=true`
        }
      }
      document.location.href = url
    }

    $jobModal.on('shown.bs.modal', function () {
      $('body')
        .css('overflow','hidden')
        .css('position','fixed')
        .css('width','100%');
    })
    .on('hide.bs.modal', () => {
      $('body')
        .css('overflow','auto')
        .css('position','inherit')
        .css('width','auto');

        let props = this.state.currentStep.props

        if (props && props.isBasicStep) {
          this.setState({currentStep: this.wizard.Steps[0]})
        }
    })

    this.wizard.scrollTo = function(selector) {
      var position = $jobModal.find(selector).position()
      $jobModal.animate({scrollTop: position.top}, 'slow');
    }

    Job.PostingProgressActions.syncStoredPostingProgress()

    // listeners
    this.wizard.Emitter.addListener('job:wizard:advanceToStep', (step, eventArgs) => { this.advanceStep(step, eventArgs) })
    this.wizard.Emitter.addListener('job:wizard:advanceToNextStep', this.advanceStep)
    this.wizard.Emitter.addListener('job:wizard:retreatToPreviousStep', this.retreatStep)
    Job.Store.addChangeListener(this.jobChanged)

    $jobModal.bootstrapValidator({ /* */ })
    this.wizard.Validator = $jobModal.data('bootstrapValidator');

    $jobModal
      .on('show.bs.modal', (e) => {
        this.initialiseTracking()
        this.initialiseJobData(e)
        browserCloseListener()
      })
      .find('#job_form')
        .on('submit', function(e) {
          e.preventDefault()
          return false;
        })
        .end()
      .find('.modal-exit')
        .on('click', handleModalExit.bind(this))
        .end()
      .find('.modal-stay')
        .on('click', function() {
          $jobModal
            .find('.close-modal-warning')
              .velocity('slideUp')
            .end()
            .find('.close')
              .rmHidden()
          return false;
        })

    SS.appFn.appMsg('job-form-loaded') // needed for mobile apps
  },

  setExclusiveBusinessId: function() {
    let businessId = SS.appFn.urlInspector.getURLParameter('pa') || null
    if (businessId) {
      Job.Data.exclusiveFor = businessId;
    }
  },

  componentWillUnmount: function() {
    this.wizard.Emitter.removeEventListener('job:wizard:advanceToStep')
    this.wizard.Emitter.removeListener('job:wizard:advanceToNextStep', this.advanceStep)
    Job.Store.removeChangeListener(this.jobChanged)
    window.removeEventListener('beforeunload', this.handleBrowserClose)
  },

  wizard: JobWizardMobile,
  stepHistory: [ JobWizardMobile.Steps[0] ],

  initialiseTracking: function () {
    if (Job.Data.id === null) {
      Job.PostingProgressActions.track = true
    }

    Job.PostingProgressActions.updateTracking({
      url: Job.Data.referrer.url,
      source: Job.Data.referrer.source,
      userId: SS.currentUserId,
      lastQuestion: 'no interaction',
      categoryId: Job.Data.category_id,
      categoryType: 'sub_category' //TODO this needs to change to Job.Data.category_type when category code gets updated @JM
    })
  },

  initialiseJobData: function(e) {
    if (typeof e.relatedTarget !== 'undefined') {
      let isLoggedInText = window.SS.currentUserId ? 'logged_in' : 'logged_out'
      let cta = $(e.relatedTarget).data('cta') || e.relatedTarget.cta || 'body'

      Job.Data.referrer.cta = `${cta}_${isLoggedInText}`
    }
  },

  handleBrowserClose: function() {
      Job.PostingProgressActions.updateTracking({ exitType: 'browser_window_exit' })
      Job.PostingProgressActions.storePostingProgress()
      window.removeEventListener('beforeunload', this.handleBrowserClose)
  },

  jobChanged: function() {
    this.setState({job: Job.Data})
  },

  stepIsValid: function() {
    const validator = JobWizardMobile.Validator
    validator.validate()
    return validator.isValid()
  },

  advanceStep: function(nextStep, eventArgs) {
    if (this.stepIsValid() || eventArgs === 'exit') {
      if (!nextStep) {
        let currentStepIndex = this.wizard.Steps.indexOf(this.state.currentStep)

        if (currentStepIndex < 0) {
          currentStepIndex = 0
        }

        nextStep = this.wizard.Steps[currentStepIndex + 1]
      }

      if (typeof eventArgs !== 'undefined') {
        this.setState(
          {currentStep: nextStep},
          function() {
            return JobWizardMobile.Emitter.emit(...eventArgs)
          }
        )
      } else {
        this.setState({currentStep: nextStep})
      }

      this.stepHistory.push(nextStep)
    }
  },

  retreatStep: function(step) {
    this.stepHistory.pop() //remove current step from history
    let previousStep = this.stepHistory[this.stepHistory.length - 1]

    this.setState({
      currentStep: previousStep
    })
  },

  handleRequest: function () {
    this.setState({
      loading: true
    })
  },

  handleRequestCompletion: function () {
    this.setState({
      loading: false
    })
  },

  renderStepOrSpinner: function() {
    return (
      <div>
        <div className={`${this.state.loading ? '' : 'hidden'}`}>
          <div className="modal-body job-form-body">
            <div className="spinner-icon text-center"/>
          </div>
        </div>
        <div className={`${this.state.loading ? 'hidden' : ''}`}>
          <this.wizard.Step
            currentStep={this.state.currentStep}
            onStepProgression={this.advanceStep}
            onStepRetreat={this.retreatStep}
            onRequest={this.handleRequest}
            onRequestCompletion={this.handleRequestCompletion}
          />
        </div>
      </div>
    )
  },

  render: function() {
    var component;

    if(this.state.currentStep.props && this.state.currentStep.props.isBasicStep) {
      component = this.state.currentStep
    }
    else {
      component = <JobWizardMobile.JobPostingForm stepComponent={this.renderStepOrSpinner()}/>
    }

    return (
      <div className="modal-dialog" role="document">
        <div className="modal-content" style={{'overflowY': 'auto'}}>
          <JobWizardMobile.CloseModalWarning hideNotPostedWarningMessage={component.props.hideNotPostedWarningMessage}/>
          <ProgressBar steps={this.wizard.Steps} currentStep={this.state.currentStep} />
          <div className="modal-component">
            {component}
          </div>
        </div>
      </div>
    )
  }
})
